import type {
  ArArticleDetail,
  ArCalendarWeek,
  ArExistingArticle,
  ArNewArticle,
  ArStat,
} from './types';

export const AR_STATS: ArStat[] = [
  { key: 'ready', label: 'Ready to publish', value: '3', tone: 'success' },
  { key: 'drafts', label: 'Drafts', value: '3', tone: 'gold' },
  { key: 'update', label: 'Existing to update', value: '5', tone: 'terra' },
  { key: 'pace', label: 'Recommended pace', value: '2/wk', tone: 'neutral' },
  { key: 'current', label: 'Your current pace', value: '0/wk', tone: 'terra' },
];

export const AR_NEW_ARTICLES: ArNewArticle[] = [
  {
    id: 'dental-implants-guide',
    title: 'How Much Do Dental Implants Cost in Brampton? (2026 Guide)',
    targetKeyword: 'dental implants cost',
    volume: 1500,
    currentRank: null,
    priority: 'high',
    estTraffic: '120–180/mo',
    category: 'Implants',
    wordCount: 2200,
    images: 4,
    status: 'ready',
    why: 'You’re not on page 1 for "dental implants cost" — a keyword worth $4,000+ per patient. Publishing this comprehensive guide closes your local content gap and builds the Topical Authority needed to outrank Smile Central.',
    outline: [
      'What Are Dental Implants?',
      'Single Tooth vs. Full Arch: Price Comparison',
      "What's Included in the Cost",
      'Financing Options & Monthly Payments',
      'Insurance Coverage',
      'Why Costs Vary Between Clinics',
      'Free Consultation + 3D Scan',
      'Before & After Gallery',
      'FAQs',
    ],
    week: 'Week 1 — April 14',
  },
  {
    id: 'emergency-er-vs-dentist',
    title: 'Emergency Dentist: When to Go to the ER vs. the Dentist',
    targetKeyword: 'emergency dentist',
    volume: 2800,
    currentRank: 2,
    priority: 'high',
    estTraffic: '200–300/mo',
    category: 'Emergency',
    wordCount: 1600,
    images: 2,
    status: 'ready',
    why: 'You’re #2 for "emergency dentist" — publishing this supporting article strengthens your topical authority on emergency dental care and could push you to #1, which gets 3x more clicks.',
    outline: [
      'Go to the ER If…',
      'Go to the Emergency Dentist If…',
      'Quick Decision Flowchart',
      'First Aid Tips',
      'Emergency Costs & Insurance',
      'Our Same-Day Process',
      'Book After Hours',
    ],
    week: 'Week 1 — April 14',
  },
  {
    id: 'teeth-whitening-guide',
    title: 'Teeth Whitening in Brampton: Methods, Cost & What Works',
    targetKeyword: 'teeth whitening',
    volume: 1800,
    currentRank: 6,
    priority: 'high',
    estTraffic: '100–150/mo',
    category: 'Cosmetic',
    wordCount: 1800,
    images: 5,
    status: 'ready',
    why: 'You’re #6 for "teeth whitening" and climbing. This dedicated article with pricing, method comparisons, and before/after photos builds the topical depth needed to break into the top 3.',
    outline: [
      'In-Office vs. Take-Home vs. OTC Comparison',
      'Professional Whitening Cost',
      'Before & After Gallery',
      'How Long Results Last',
      "Who's a Good Candidate?",
      'Our $199 Spring Special',
      'FAQs',
    ],
    week: 'Week 2 — April 21',
  },
  {
    id: 'invisalign-complete-guide',
    title: 'Invisalign for Adults: Complete Guide (Diamond Provider)',
    targetKeyword: 'invisalign near me',
    volume: 1200,
    currentRank: 8,
    priority: 'medium',
    estTraffic: '80–120/mo',
    category: 'Cosmetic',
    wordCount: 2400,
    images: 6,
    status: 'draft',
    why: 'You’re a Diamond-level Invisalign provider but your website barely mentions it. This cornerstone article establishes your topical authority and leverages your credentials to compete for this high-value keyword.',
    outline: [
      'How Invisalign Works',
      'Am I a Candidate?',
      'Month-by-Month Timeline',
      'Cost & Financing',
      'Invisalign vs. Braces',
      'Diamond Provider Advantage',
      'Before & After Gallery',
      'Free Smile Preview',
      'FAQs',
    ],
    week: 'Week 2 — April 21',
  },
  {
    id: 'spanish-emergency-guide',
    title: 'Servicios Dentales de Emergencia — Hablamos Español',
    targetKeyword: 'dentista cerca de mi',
    volume: 650,
    currentRank: null,
    priority: 'medium',
    estTraffic: '40–60/mo',
    category: 'Spanish',
    wordCount: 1200,
    images: 3,
    status: 'draft',
    why: '30% of your neighborhood speaks Spanish, yet you have zero Spanish content online. This article establishes your presence in a nearly uncontested niche — likely ranking on page 1 within weeks.',
    outline: [
      'Servicios de Emergencia',
      'Cómo Reservar',
      'Equipo Bilingüe',
      'Seguros Aceptados',
      'Financiamiento',
      'Ubicación y Horarios',
    ],
    week: 'Week 3 — April 28',
  },
  {
    id: 'child-first-visit',
    title: "Your Child's First Dental Visit: What Parents Need to Know",
    targetKeyword: 'family dentist',
    volume: 2200,
    currentRank: 3,
    priority: 'medium',
    estTraffic: '90–130/mo',
    category: 'Family',
    wordCount: 1400,
    images: 4,
    status: 'draft',
    why: 'You’re #3 for "family dentist" and climbing. This article deepens your topical authority in the family dental niche — targeting parents with young children, a high-LTV demographic where one child often brings siblings and parents.',
    outline: [
      'When Should a Child First See the Dentist?',
      'How We Make It Fun',
      'What Happens at the First Visit',
      'Tips to Prepare Your Child',
      'Common Questions',
      "Book Your Child's Visit",
    ],
    week: 'Week 3 — April 28',
  },
];

export const AR_EXISTING_ARTICLES: ArExistingArticle[] = [
  {
    id: 'healthy-smile-tips',
    title: '5 Tips for a Healthy Smile',
    targetKeyword: 'dental hygiene tips',
    url: '/blog/healthy-smile-tips',
    published: 'Nov 2025',
    wordCount: 620,
    status: 'replace',
    currentRank: null,
    problems: ['Too short at 620 words', 'No images', 'Missing meta description', '5 months old'],
    newTitle: '10 Daily Habits for a Healthier Smile (Backed by Your Dentist)',
    newWordCount: 1350,
    newImages: 4,
    newOutline: [
      'Why Daily Habits Matter More Than Twice-a-Year Cleanings',
      'The 10 Habits',
      'Common Mistakes That Damage Your Teeth',
      'When to See a Dentist vs. Wait',
      'Quick Self-Check: Are Your Gums Healthy?',
      'Book Your Next Checkup',
    ],
    preview: `We all know we should brush twice a day — but there's so much more to keeping your smile healthy between dental visits. As dentists, we see the same preventable problems every week. Here are 10 simple daily habits that make the biggest difference, based on what we actually see in our Brampton practice.

1. Brush for a Full Two Minutes (Most People Don't)

Most patients think they brush for two minutes, but studies show the average is closer to 45 seconds. Try setting a timer on your phone — you'll be surprised how long two minutes actually feels. Use gentle circular motions, and don't forget the backs of your molars.

2. Floss Before You Brush, Not After

This one surprises most patients. Flossing first loosens debris between teeth, and then brushing sweeps it away. If you floss after, that debris can stay trapped against your enamel.`,
  },
  {
    id: 'dental-emergency',
    title: 'What to Do in a Dental Emergency',
    targetKeyword: 'emergency dentist',
    url: '/blog/dental-emergency',
    published: 'Sep 2025',
    wordCount: 980,
    status: 'update',
    currentRank: 2,
    problems: ['Missing "ER vs. dentist" section', 'No internal links to emergency page', '7 months old'],
    newTitle: 'Dental Emergency Guide: What to Do, When to Call & How to Book Same-Day',
    newWordCount: 1650,
    newImages: 3,
    newOutline: [
      'Is It a Dental Emergency? (Checklist)',
      'ER vs. Emergency Dentist',
      'First Aid for Common Emergencies',
      'Knocked-Out Tooth: The 30-Minute Window',
      'Cracked or Broken Tooth',
      'Severe Toothache',
      'Our Same-Day Process',
      'Book After Hours',
    ],
    preview: `A dental emergency can be scary — but knowing what to do in the first few minutes can save your tooth and reduce your pain. This guide covers the most common dental emergencies we see at our Brampton practice.

Is It a Dental Emergency?

Not every dental problem needs same-day care. Here's a quick way to decide:

→ Come in today: Knocked-out tooth, broken tooth with sharp edges, severe pain, swelling in your face or jaw, bleeding that won't stop
→ Can wait 1-2 days: Lost filling, chipped tooth with no pain, minor sensitivity
→ Go to the ER: Difficulty breathing or swallowing, uncontrollable bleeding, jaw injury from trauma`,
  },
  {
    id: 'office-tour',
    title: 'Our New Office Tour',
    targetKeyword: 'dentist office tour',
    url: '/blog/office-tour',
    published: 'Jun 2024',
    wordCount: 340,
    status: 'replace',
    currentRank: null,
    problems: ['Only 340 words', 'No SEO value', 'Photos are 2 years old', 'Zero search traffic'],
    newTitle: 'Tour Our Brampton Dental Office — What to Expect at Your First Visit',
    newWordCount: 1100,
    newImages: 8,
    newOutline: [
      'Welcome to Smile Dental Downtown',
      "Waiting Area & Kids' Zone",
      'Treatment Rooms & Technology',
      'Meet Our Team',
      'Parking & Directions',
      'What to Expect at Your First Visit',
      'Book a Visit',
    ],
    preview: `Visiting a new dentist can feel uncertain — you don't know what the office looks like, who you'll meet, or what the experience will be like. That's why we're giving you a full look inside our Brampton office before you even walk through the door.

Our Waiting Area

We designed our waiting area to feel more like a living room than a clinic. Comfortable seating, complimentary coffee and water, free Wi-Fi, and a dedicated play area for kids with books and games.

Treatment Rooms

Each treatment room has a ceiling-mounted TV so you can watch Netflix during your appointment — yes, really. We also use the latest digital X-ray technology, which uses 80% less radiation than traditional film X-rays.`,
  },
  {
    id: 'regular-checkups',
    title: 'Benefits of Regular Dental Checkups',
    targetKeyword: 'dental checkup',
    url: '/blog/regular-checkups',
    published: 'Oct 2025',
    wordCount: 850,
    status: 'update',
    currentRank: 7,
    problems: ['No local keywords', 'Missing Google review rating', 'No family imagery'],
    newTitle: 'Why Regular Dental Checkups Matter (From Your Brampton Family Dentist)',
    newWordCount: 1200,
    newImages: 3,
    newOutline: [
      'What We Check During an Exam',
      'Hidden Problems Only a Dentist Can Catch',
      'How Often Should You Come In?',
      'What Our Brampton Patients Say',
      'Insurance, Hours & Online Booking',
      "Book Your Family's Checkup",
    ],
    preview: `"I don't have any pain, so I don't need to go to the dentist." We hear this from patients every single week — and unfortunately, by the time dental problems cause pain, they're usually much more expensive to fix.

What We Check (That You Can't See at Home)

Your checkup is more than just looking at your teeth. We're checking for:

→ Early cavities between teeth (invisible without X-rays)
→ Gum disease signs (before it causes bone loss)
→ Oral cancer screening (a quick, painless visual exam)
→ Bite alignment changes
→ Wear patterns that suggest grinding`,
  },
  {
    id: 'dental-insurance',
    title: 'Understanding Dental Insurance',
    targetKeyword: 'dental insurance',
    url: '/blog/dental-insurance',
    published: 'Aug 2025',
    wordCount: 1100,
    status: 'update',
    currentRank: 5,
    problems: ['Doesn’t list specific plans accepted', 'No comparison table', 'Missing CTA'],
    newTitle: "Dental Insurance in Brampton: What's Covered & How to Maximize Benefits",
    newWordCount: 1500,
    newImages: 2,
    newOutline: [
      'Insurance Basics (Plain English)',
      "What's Covered: Preventive, Basic, Major",
      'Plans We Accept (Full List)',
      'Check Your Coverage Before Your Visit',
      'Maximizing Benefits Before Year-End',
      'No Insurance? Membership Plan',
      'Book — We Handle Paperwork',
    ],
    preview: `Dental insurance can be confusing — what's covered, what's not, and how do you know if you're getting the most out of your plan? We've put together this straightforward guide based on the questions our Brampton patients ask most often.

The Three Tiers of Coverage

Most dental insurance plans divide services into three categories:

Preventive (usually 100% covered): Cleanings, exams, X-rays — the basics that keep small problems from becoming big ones.
Basic (typically 70-80% covered): Fillings, simple extractions, root canals on front teeth.
Major (usually 50% covered): Crowns, bridges, implants, dentures — the bigger procedures.`,
  },
];

export const AR_CALENDAR_WEEKS: ArCalendarWeek[] = [
  { label: 'Week 1 — Apr 14', articleIds: ['dental-implants-guide', 'emergency-er-vs-dentist'] },
  { label: 'Week 2 — Apr 21', articleIds: ['teeth-whitening-guide', 'invisalign-complete-guide'] },
  { label: 'Week 3 — Apr 28', articleIds: ['spanish-emergency-guide', 'child-first-visit'] },
  { label: 'Week 4 — May 5', articleIds: [] },
];

const dentalImplantsDetail: ArArticleDetail = {
  id: 'dental-implants-guide',
  title: 'How Much Do Dental Implants Cost in Brampton? (2026 Guide)',
  targetKeyword: 'dental implants cost',
  volume: 1500,
  category: 'Implants',
  wordCount: 2200,
  readTime: '9 min',
  status: 'ready',
  url: '/blog/dental-implants-cost-brampton',
  meta: {
    title: 'Dental Implants Cost in Brampton 2026 — Pricing, Financing & What to Expect',
    description:
      'How much do dental implants cost in Brampton? Full pricing guide for single implants, All-on-4, and bridges. Financing from $89/mo. Free consultation available.',
    slug: '/blog/dental-implants-cost-brampton',
  },
  images: [
    {
      id: 1,
      name: 'dental-implant-hero.jpg',
      type: 'hero',
      size: '245 KB',
      dimensions: '1200 × 630',
      alt: 'Dental implant procedure illustration showing titanium post, abutment, and crown',
    },
    {
      id: 2,
      name: 'implant-cost-comparison.png',
      type: 'comparison',
      size: '180 KB',
      dimensions: '800 × 500',
      alt: 'Comparison table showing single implant, bridge, and All-on-4 pricing',
    },
    {
      id: 3,
      name: 'before-after-implants.jpg',
      type: 'before-after',
      size: '320 KB',
      dimensions: '1200 × 600',
      alt: 'Before and after dental implant results at Smile Dental Brampton',
    },
    {
      id: 4,
      name: 'financing-infographic.png',
      type: 'infographic',
      size: '150 KB',
      dimensions: '800 × 1000',
      alt: 'Dental implant financing options infographic showing monthly payment plans',
    },
  ],
  sections: [
    { type: 'h1', text: 'How Much Do Dental Implants Cost in Brampton? (2026 Guide)' },
    {
      type: 'p',
      text: 'If you’re considering dental implants, one of your first questions is probably "how much will this cost?" It’s a fair question — and unfortunately, many dental websites give you a vague answer like "it depends."',
    },
    {
      type: 'p',
      text: 'We believe in price transparency. In this guide, we’ll break down exactly what dental implants cost at our Brampton practice, what’s included in that price, your financing options, and how to figure out what your insurance will cover.',
    },
    { type: 'image', imageIdx: 0 },
    { type: 'h2', text: 'What Are Dental Implants? (Plain-English Explanation)' },
    {
      type: 'p',
      text: 'A dental implant is a small titanium post that’s placed into your jawbone where a tooth is missing. Think of it like an artificial tooth root. Once the implant bonds with your bone (this takes about 3-4 months), we attach a custom-made crown on top that looks and functions exactly like a natural tooth.',
    },
    {
      type: 'p',
      text: "Unlike dentures, implants don't slip or shift. Unlike bridges, they don't require grinding down healthy adjacent teeth. They're the closest thing modern dentistry has to growing a new tooth.",
    },
    { type: 'h2', text: 'Single Tooth vs. Full Arch: Price Comparison' },
    {
      type: 'p',
      text: "Here's what dental implants typically cost at our Brampton practice in 2026. These prices include everything — the consultation, the implant surgery, the abutment, and the final crown.",
    },
    {
      type: 'table',
      headers: ['Procedure', 'Price Range', "What's Included", 'Timeline'],
      rows: [
        ['Single Tooth Implant', '$3,200 – $4,500', 'Consultation, surgery, abutment, crown', '4-6 months'],
        ['Implant Bridge (3-4 teeth)', '$6,500 – $10,000', '2 implants + bridge prosthetic', '4-6 months'],
        ['All-on-4 (Full Arch)', '$18,000 – $25,000', '4 implants + full arch prosthetic', 'Same day temp, 6 mo final'],
        ['Bone Graft (if needed)', '$500 – $1,200', 'Bone augmentation before implant', 'Adds 3-4 months'],
      ],
    },
    { type: 'image', imageIdx: 1 },
    { type: 'h2', text: "What's Included in the Cost" },
    {
      type: 'p',
      text: "When we quote you a price for dental implants, it includes everything from start to finish. Some clinics quote a lower price but then add fees for each step. Here's exactly what our price covers:",
    },
    {
      type: 'list',
      items: [
        'Initial consultation and 3D CT scan',
        'Custom treatment planning',
        'The implant surgery (including local anesthesia)',
        'The abutment (connector piece)',
        'The custom-made porcelain crown',
        'All follow-up visits during healing',
        'A 5-year warranty on the implant and crown',
      ],
    },
    { type: 'h2', text: 'Financing Options & Monthly Payments' },
    {
      type: 'p',
      text: "We understand that dental implants are a significant investment. That's why we offer several ways to make them affordable:",
    },
    {
      type: 'list',
      items: [
        'CareCredit financing: 0% interest for 12 months, or extended plans from $89/month',
        'In-house payment plans: Split your treatment into 3-4 monthly payments with no interest',
        "Insurance maximization: We'll help you use your annual maximum toward implants",
        'Multi-tooth discount: 10% off when doing 2 or more implants in the same treatment',
      ],
    },
    { type: 'image', imageIdx: 3 },
    { type: 'h2', text: "Insurance Coverage — What's Typically Covered" },
    {
      type: 'p',
      text: 'Most dental insurance plans classify implants as a "major" procedure, which means they typically cover 50% of the cost up to your annual maximum (usually $1,500-$2,500). Some newer plans cover implants more generously.',
    },
    {
      type: 'p',
      text: "We'll submit a pre-authorization to your insurance before starting treatment so you'll know exactly what your out-of-pocket cost will be. No surprises.",
    },
    { type: 'h2', text: 'Why Costs Vary Between Clinics' },
    {
      type: 'p',
      text: 'You might see implant prices ranging from $1,500 to $6,000 for a single tooth online. Here’s why: some clinics quote only the surgery fee (not including the crown), some use lower-quality implant brands, and some add fees for each appointment separately. Always ask for an all-inclusive price so you can compare apples to apples.',
    },
    { type: 'h2', text: 'Our Approach: Free Consultation + 3D Scan' },
    {
      type: 'p',
      text: 'Not sure if implants are right for you? We offer a free implant consultation that includes a 3D CT scan of your jaw, a personalized treatment plan, and an exact cost breakdown with insurance estimates — all before you commit to anything.',
    },
    { type: 'image', imageIdx: 2 },
    { type: 'h2', text: 'Before & After Gallery' },
    {
      type: 'p',
      text: "Here are real results from patients at our Brampton practice who chose dental implants. Each case is different, and during your consultation, we'll show you what results you can expect for your specific situation.",
    },
    { type: 'h2', text: 'Frequently Asked Questions' },
    {
      type: 'p',
      text: 'How long do dental implants last? With proper care, dental implants can last 25 years or more. The crown may need replacement after 10-15 years due to normal wear.',
    },
    {
      type: 'p',
      text: "Is the procedure painful? Most patients say it's less painful than a tooth extraction. We use local anesthesia during the procedure and prescribe pain medication for the first few days of recovery. Sedation options are also available.",
    },
    {
      type: 'p',
      text: "Am I too old for implants? Age is rarely a factor. We've successfully placed implants in patients in their 80s. The key factor is having enough healthy jawbone, which we assess during your free 3D scan.",
    },
    {
      type: 'cta',
      text: 'Ready to find out if dental implants are right for you? Book your free consultation — includes a 3D scan and personalized cost estimate.',
    },
  ],
};

export const AR_ARTICLE_DETAILS: Record<string, ArArticleDetail> = {
  'dental-implants-guide': dentalImplantsDetail,
};

/** Empty draft for /articles/new — user builds sections dynamically. */
export const AR_ARTICLE_CREATE_DRAFT: ArArticleDetail = {
  id: 'new',
  title: '',
  targetKeyword: '',
  volume: 0,
  category: null,
  wordCount: 0,
  readTime: '—',
  status: 'draft',
  url: null,
  meta: {
    title: '',
    description: '',
    slug: '',
  },
  images: [],
  sections: [],
};
